import React from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

const RegistrationSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [copied, setCopied] = useState(false);
  const apiKey = location.state?.apiKey;

  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!apiKey) {
    return <Navigate to="/external" replace />;
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Body className="text-center">
              <h2 className="mb-4">Registration Successful!</h2>
              <Alert variant="success" className="mb-4">
                Your API key has been generated successfully.
              </Alert>

              <div className="api-key-container mb-4">
                <h5 className="mb-3">Your API Key:</h5>
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <code className="bg-light p-3 rounded" style={{ flex: 1 }}>
                    {apiKey}
                  </code>
                  <Button
                    variant="outline-primary"
                    onClick={handleCopy}
                    className="copy-button"
                  >
                    <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
                  </Button>
                </div>
                {copied && (
                  <small className="text-success mt-2">Copied to clipboard!</small>
                )}
              </div>

              <div className="alert alert-warning">
                <h5>Important!</h5>
                <p className="mb-0">
                  Please save this API key. You won't be able to see it again.
                </p>
              </div>

              <div className="d-grid gap-2 mt-4">
                <Button variant="primary" onClick={() => navigate('/login')}>
                  Proceed to Login
                </Button>
                <Button variant="outline-secondary" onClick={() => navigate('/external')}>
                  Register Another Client
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RegistrationSuccess; 